<template>
  <div class="Video_release"  v-loading="loading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-form label-width="80px" :rules="rules" :model="ruleForm" ref="ruleForm" style="padding-top: 20px;">
      <el-form-item label="模块" prop="RotaChartModule">
        <el-select v-model="ruleForm.RotaChartModule" placeholder="活动区域">
          <el-option v-for="(item,i) in value7" :key="i" :label="item.cDicEnglishValue" :value="item.dicKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="轮播图标题" prop="MaterialName">
        <el-input style="width: 300px;" v-model="ruleForm.MaterialName" placeholder="请输入轮播图标题"></el-input>
      </el-form-item>
      <el-form-item label="上传图片" style="height: 180px;">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg 建议比例：2.5:1</p>
      </el-form-item>
      <el-form-item label="排序">
        <el-input :rows="2" placeholder="请输入内容" v-model="LineNumber"></el-input>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-switch v-model="IsActive"></el-switch>
      </el-form-item>
      <el-form-item label="内容跳转地址" prop="JumpContentLink">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ruleForm.JumpContentLink"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">{{ ne }}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      ne:"立即创建",
      IsActive:true,
      imageUrl: "",
      loading: false,
      ruleForm: {
        MaterialName: "",//图片标题
        RotaChartModule: "",
        JumpContentLink: "",//版权声明
      },
      pictureFile: "",//图片文件
      LineNumber: "1",//排序
      MaterialKey: "",//(修改传)
      value7: [],
      type: '',
      rules: {
        MaterialName: [
          { required: true, message: '请输入轮播图标题', trigger: 'blur' },
        ],
        RotaChartModule: [
          { required: true, message: '请选择模块', trigger: 'change' }
        ],
        JumpContentLink:[
          { required: true, message: '请输入轮播图跳转地址', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
    this.type = [this.$route.query.type][0];
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 45 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value7 = res.Data;
      }
    })
    if (this.type == 2) {
      this.ne = "确定修改"
      this.$Http_Post('management/getContentDetails', { MaterialKey: [this.$route.query.MaterialKey][0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.ruleForm.RotaChartModule = res.Data.rotaChartModule;
          this.ruleForm.MaterialName = res.Data.materialName;
          this.imageUrl = res.Data.materialPath;
          this.ruleForm.JumpContentLink = res.Data.jumpContentLink;
          this.LineNumber = res.Data.lineNumber;
          this.IsActive = res.Data.isActive == 1 ? true : false;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    } else {
      this.ne = "立即创建";
    }
  },
  methods: {
    submitForm(formName) {//创建
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.iscontinuous = true
          this.loading = true
          var from = new FormData();
          from.append('MaterialName', this.ruleForm.MaterialName);
          from.append('LineNumber', this.LineNumber);
          from.append('JumpContentLink', this.ruleForm.JumpContentLink);
          from.append('RotaChartModule', this.ruleForm.RotaChartModule);
          from.append('IsActive', this.IsActive ? 1 : 0);
          if (this.type == 2) {
            from.append('MaterialKey', [this.$route.query.MaterialKey][0]);
            if (this.pictureFile.raw) {
              from.append('pictureFile', this.pictureFile.raw);
            } else {
              from.append('pictureFile', this.imageUrl);
            }
          } else {
            from.append('pictureFile', this.pictureFile.raw);
          }
          this.$Http_Post('management/operationRotationChart', from, { 'Content-Type': 'multipart/form-data', }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.iscontinuous = false
              this.Global.request_successful(res.Message);
              this.loading = false;
              this.$router.push({ path: '/propagate/Rotation_chart_management' })
            } else {
              this.iscontinuous = false
              this.loading = false
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.pictureFile = file;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
  },
}
</script>
<style>
  .Video_release{background-color: #fff;height: 100%;width: 100%;}
  
  .avatar-uploader .el-upload:hover {border-color: #409eff;}
  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
  .avatar {width: 215px;height: 148px;display: block;}
  .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
  .avatar-uploader {position: absolute;top: 0px;left: 0px;}
  .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
  .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
  .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
  .Video_release .el-form-item__label{width: 110px !important;}
  .Video_release .el-form-item__content{margin-left: 120px !important;}
  .Video_release .el-input{width: 300px;}
  .Video_release .el-textarea{width: 500px;}
</style>
